{
  "CUSTOM_ROLE": {
    "HEADER": "Prilagođene uloge",
    "LEARN_MORE": "Saznajte više o prilagođenim ulogama",
    "DESCRIPTION": "Prilagođene uloge izrađuje vlasnik ili administrator računa. Te se uloge mogu dodijeliti agentima kako bi se odredili njihov pristup i dopuštenja unutar računa. Prilagođene uloge mogu se izraditi s određenim dopuštenjima i razinama pristupa prema potrebama organizacije.",
    "HEADER_BTN_TXT": "Dodaj prilagođenu ulogu",
    "LOADING": "Dohvaćanje prilagođenih uloga...",
    "SEARCH_404": "Ne postoji rezultat za zadano pretraživanje.",
    "PAYWALL": {
      "TITLE": "Nadogradite za izradu prilagođenih uloga",
      "AVAILABLE_ON": "Značajka prilagođenih uloga dostupna je samo u planovima Business i Enterprise.",
      "UPGRADE_PROMPT": "Nadogradite plan za pristup naprednim značajkama kao što su upravljanje timovima, automatizacije, prilagođeni atributi i drugo.",
      "UPGRADE_NOW": "Nadogradi sada",
      "CANCEL_ANYTIME": "Plan možete promijeniti ili otkazati u bilo kojem trenutku"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Značajka prilagođenih uloga dostupna je samo u plaćenim planovima.",
      "UPGRADE_PROMPT": "Nadogradite na plaćeni plan za pristup naprednim značajkama kao što su zapisnici revizije, kapacitet agenata i drugo.",
      "ASK_ADMIN": "Za nadogradnju se obratite administratoru."
    },
    "LIST": {
      "404": "U ovom računu nema dostupnih prilagođenih uloga.",
      "TITLE": "Upravljanje prilagođenim ulogama",
      "DESC": "Prilagođene uloge izrađuje vlasnik ili administrator računa. Te se uloge mogu dodijeliti agentima kako bi se odredili njihov pristup i dopuštenja unutar računa. Prilagođene uloge mogu se izraditi s određenim dopuštenjima i razinama pristupa prema potrebama organizacije.",
      "TABLE_HEADER": {
        "NAME": "Ime",
        "DESCRIPTION": "Opis",
        "PERMISSIONS": "Dopuštenja",
        "USAGE_COUNT": "Koristi",
        "ACTIONS": "Radnje"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Upravljanje svim razgovorima",
      "CONVERSATION_UNASSIGNED_MANAGE": "Upravljanje nedodijeljenim razgovorima i razgovorima dodijeljenima njima",
      "CONVERSATION_PARTICIPATING_MANAGE": "Upravljanje razgovorima u kojima sudjeluju i razgovorima dodijeljenima njima",
      "CONTACT_MANAGE": "Upravljanje kontaktima",
      "ACCESS_ALL_REPORTS": "Pregled svih izvješća",
      "KNOWLEDGE_BASE_MANAGE": "Upravljanje bazom znanja",
      "DATA_ASSISTANT_MANAGE": "Upravljanje podatkovnim asistentom",
      "CALL_RECORDING_ACCESS": "Pristup svim snimkama poziva"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Ime",
        "PLACEHOLDER": "Unesite naziv.",
        "ERROR": "Ime je obavezno."
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Unesite opis.",
        "ERROR": "Opis je obavezan."
      },
      "PERMISSIONS": {
        "LABEL": "Dopuštenja",
        "ERROR": "Dopuštenja su obavezna."
      },
      "CANCEL_BUTTON_TEXT": "Odustani",
      "API": {
        "ERROR_MESSAGE": "Could not connect to Woot Server, Please try again later"
      }
    },
    "ADD": {
      "TITLE": "Dodaj prilagođenu ulogu",
      "DESC": " Prilagođene uloge omogućuju izradu uloga s određenim dopuštenjima i razinama pristupa prema potrebama organizacije.",
      "SUBMIT": "Pošalji",
      "API": {
        "SUCCESS_MESSAGE": "Prilagođena uloga uspješno je dodana."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Uredi",
      "TITLE": "Uredi prilagođenu ulogu",
      "DESC": " Prilagođene uloge omogućuju izradu uloga s određenim dopuštenjima i razinama pristupa prema potrebama organizacije.",
      "SUBMIT": "Ažuriraj",
      "API": {
        "SUCCESS_MESSAGE": "Prilagođena uloga uspješno je ažurirana."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Prilagođena uloga uspješno je izbrisana.",
        "ERROR_MESSAGE": "Could not connect to Woot Server, Please try again later"
      },
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Jeste li sigurni da želite izbrisati ",
        "YES": "Da, izbriši ",
        "NO": "Ne, zadrži "
      }
    }
  }
}
